import React from 'react';

const ContentBlock = React.memo(({children}) => <div className="tile-square__content-block">{children}</div>);

export default ContentBlock;
